<template>
  <div :class="{'icon-link': icon}">
    <q-icon v-if="icon" :name="icon" class="q-mx-sm" :color="color" aria-hidden="true" />
    <a :class="classes" :href="correctedHref" :target="target">
      <slot>
        {{ label }}
      </slot>
      <span class="sr-only" v-if="active">huidige pagina</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      required: true,
    },
    linkClasses: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '_self',
    },
    active: {
      type: Boolean,
      default: false,
    },
    isLocal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      if (this.linkClasses) {
        return `${this.linkClasses} ${this.active ? 'active' : ''}`
      }

      return `link link--${this.color} ${this.active ? 'active' : ''}`
    },
    correctedHref () {
      if (this.isLocal) return this.href
      if (/^(((http|https):\/\/)|mailto:)/.test(this.href)) return this.href
      return `http://${this.href}`
    },
  },
}
</script>
